/**
 * set of functions to enforce a data structure
 */
import config from 'config/config';
import stripTags from 'src/utils/stripTags';
import fieldsToStructure from './fieldsToStructure';

const preservedFields = [
  'dateOfBirth',
  'email',
  'gender',
  'groups',
  'isDeleted',
  'isInMyAreaEnabled',
  'isSharingEnabled',
  'isUserFollowsEnabled',
  'isUsersImFollowingPublic',
  'notificationPreference',
  'privateFieldsFetched',
  'dateCreated',
  'unverifiedEmail',
  'permissions',
];
const getId = user => user.id || user.userId;
const avatar = hash => config.cdn.avatars + hash + config.avatars.smallSuffix;
const formatHttps = url => url && url.substring(0, 6) !== 'https:' ? 'https:' + url : url;

const structure = {
  ...fieldsToStructure(preservedFields),
  id: getId,

  avatar(user) {
    if (user.userImageHash) {
      return avatar(user.userImageHash);
    }

    const url = user.avatar ||
      user.imageUrl ||
      user.profileImageSmall ||
      user.profileImageMedium ||
      user.userProfilePictureUrl ||
      user.userImageUrlSmall;

    return formatHttps(url) || undefined;
  },

  avatarMedium(user) {
    return formatHttps(user.profileImageMedium || user.userImageUrlMedium) || undefined;
  },

  username(user) {
    return user.username;
  },

  postCount(user) {
    return user.totalPosts || undefined;
  },

  followerCount(user) {
    return user.totalFollowers ||
      (typeof user.followers === 'number' && user.followers) ||
      undefined;
  },

  biography(user) {
    return user.aboutMe ||
      stripTags(user.formattedAboutMe) ||
      undefined;
  },

  banner(user) {
    let url = user.bannerImage;

    if (url && url.substring(0, 6) !== 'https:') {
      url = 'https:' + url;
    }

    return url || undefined;
  },

  isFollowing(user) {
    return user.isFollowedByCurrentUser || user.isFollowing;
  },

  isHidden(user) {
    return user.isDeleted || (!user.userId && !user.id);
  },

  roles(user) {
    return user.userRoles || user.roles || [];
  },
};

export default structure;
